<template>
  <div class="vehicleActivityWamp">
    <banner :queryId="thisPageId" :bannerList="data.Banner" v-if="type.Banner"/>
    <home-tip :queryId="thisPageId" :sendData="data.Home_Tip" v-if="type.Home_Tip"/>
    <home-tip :queryId="thisPageId" :sendData="data.ToBeCarOwnerGuide" v-if="type.ToBeCarOwnerGuide"/>
    <home-tip :queryId="thisPageId" :sendData="data.BeToCarOwnerBtn" v-if="type.BeToCarOwnerBtn"/>
    <product-hot :queryId="thisPageId" :addList="data.Product_Hot" v-if="type.Product_Hot"/>
    <product-top :queryId="thisPageId" :sendData="data.Product_Top" v-if="type.Product_Top"/>
  </div>
</template>

<script>
  import { resourceUrl, orderSource } from "@/utils/env";

  import homeTip from "@/components/homeTip"; // 首页模板
  import Banner from "@/components/Banner"; // 首页模板
  import productTop from "@/components/productTop"; // 车型模板 - 成都机场
  import productHot from "@/components/productHot"; // 车型模板 - 红旗车
  export default {
    name: 'vehicleActivity',
    components: {
      Banner,
      homeTip,
      productHot,
      productTop
    },
    data(){
      return {
        resourceUrl: resourceUrl,
        orderSource: orderSource,
        thisPageId: '',
        data: {
          Home_Tip: [], // 首页 活动的填充位
          Product_Top: [], // 顶部活动（车型列表）
          Product_Hot: [], // 热门活动（车型列表）
          ToBeCarOwnerGuide: [], // 个人中心 名字下面广告
          Banner: [], // banner
          BeToCarOwnerBtn: [], // 成为车主（个人中心）
        },
        type: {
          Home_Tip: false,
          Product_Top: false,
          Product_Hot: false,
          ToBeCarOwnerGuide: false,
          Banner: false,
          BeToCarOwnerBtn: false,
        }
      }
    },
    created () {
      this.initData();
    },
    mounted () { },
    methods: {
      initData(){
        // let _ww = window.screen.availWidth;
        // let _hh = window.screen.availHeight;
        // alert('windows宽：' + _ww + ',' + 'windows高：' + _hh);
        let res =  this.$route.query || {};
        if( res.orgID ){ localStorage.setItem('orgID', res.orgID) }
        if( res.start ){ localStorage.setItem('startTime', res.start) }
        if( res.end ){ localStorage.setItem('stopTime', res.end) }
        if( res.bizChannel ){ localStorage.setItem('bizChannel', res.bizChannel) }
        if( res.adSace ){ this.thisPageId = res.adSace }
        if( res.data ){
          let dataList = res.data || null;
          if(typeof res.data =='string'){
            dataList = JSON.parse(res.data);
            console.log(dataList)
          }
          this.data.Product_Hot = [];
          this.data.Home_Tip = [];
          this.data.Product_Top = [];
          for( let i in dataList ){
            for( let j in this.type ) {
              if (dataList[i].TemplateCode == j) {
                this.type[j] = true;
                this.data[j].push(dataList[i]);
              }
            }
          }
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  .vehicleActivityWamp {}
</style>
